import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = { class: "router" }
const _hoisted_3 = {
  key: 0,
  class: "footer"
}
const _hoisted_4 = { class: "footer-copyright" }

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/Breadcrumb.vue'
import CustomRouterLink from './components/CustomRouterLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const blankPage = computed(() => ['weather', 'sunday'].includes(useRoute().name as string))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(blankPage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Breadcrumb)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_unref(blankPage) ? 'content-blank' : 'content-offset')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      (!_unref(blankPage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(CustomRouterLink, {
                type: "big",
                to: "/"
              }),
              _createTextVNode(" © 2025 ")
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})